// Primary English Learning Data
// Main index file that imports and consolidates all grade-specific data
// Based on Primary English Learning P1-P6 Topics.txt

import { p1Data } from './primaryEnglish/p1Data';
import { p2Data } from './primaryEnglish/p2Data';
import { p3Data } from './primaryEnglish/p3Data';
import { p4Data } from './primaryEnglish/p4Data';
import { p5Data } from './primaryEnglish/p5Data';
import { p6Data } from './primaryEnglish/p6Data';

export const primaryEnglishData = {
  p1: p1Data,
  p2: p2Data,
  p3: p3Data,
  p4: p4Data,
  p5: p5Data,
  p6: p6Data
};

// Export individual grade data for direct access
export { p1Data, p2Data, p3Data, p4Data, p5Data, p6Data };

// Metadata for the entire Primary English module
export const primaryEnglishMetadata = {
  moduleId: 'primary-english',
  moduleName: 'Primary English Learning',
  moduleDescription: 'Comprehensive English learning materials for Primary 1-6 students',
  version: '1.0.0',
  lastUpdated: '2024-01-01',
  totalGrades: 6,
  totalTopics: 120, // 20 topics per grade
  totalQuestions: 1200, // 10 questions per topic
  dataStructure: {
    grades: 'p1-p6',
    topicsPerGrade: 20,
    questionsPerTopic: 10,
    fieldsPerQuestion: ['question', 'answer', 'explanation']
  }
}; 